import { Injectable, Output, EventEmitter, Directive } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ServerConn } from './serverConn.service';
import { AppService } from './app.service';

@Injectable({
    providedIn: 'root'
})
export class ConsultasService {

  data: any[] = [];
  pending: any[] = [];
  length = 0;
  lact: any[] = [];
  // @Output()
  needUpdate: EventEmitter<any> = new EventEmitter();
  selectedCEA = '';
  pendingData = false;
  pendingSearch = [];

  constructor(
    private server: ServerConn,
    private appSvc: AppService,
    private router: Router,
  ) { }

  get(doctype: string | string[] = 'pedidos', filter: any = '', tblstart = 0, tbllimit = 0, tblorder = '', recientes = false): Observable<any> {
    if (!this.pendingData) {
      return this.server.post(
        'inquiries',
        {
          t: doctype,
          tblfilter: filter,
          tblstart: tblstart,
          tbllimit: tbllimit,
          tblorder: tblorder,
          recientes: recientes,
        },
        true
      )
      .pipe(
        tap(
          (res: any) => {
            const data = (typeof res.json !== 'undefined') ? res.json() : res;
            this.data = data.data;
          }
        )
      );
    } else {
      this.pendingData = false;
      return of({
        result: true,
        data: this.data
      });
    }
  }

  getById(id, doctype): Observable<any> {
    /**
     * Retornamos una orden
     */
    return this.server.get(
      'inquiries/' + doctype + '/' + id
    );
  }

  getByIdent(ident, doctype): Observable<any> {
    /**
     * Retornamos las órdenes que contenga un identificador concreto o parte de él
     */
    return this.server.get(
      'inquiries/' + doctype + '/by/ident',
      {
        search: ident
      }
    ).pipe(
      tap(
        (res: any) => {
          if (res.result) {
            this.appSvc.documentsFilterPending = true;
            this.appSvc.documentsFilter = {
              color: 'primary',
              field: 'id',
              dbfield: 'id',
              name: 'id',
              label: 'Id',
              bitwise: '&&',
              operation: 'in',
              explanation: 'id in (...)',
              value: res.data.join(','),
              selected: true,
              isgroup: false
            };
            if (this.router.url !== '/documentos') {
              this.router.navigateByUrl('/documentos');
            } else {
              this.needUpdate.emit(res.data);
            }
            // this.pendingData = true;
            // this.pendingSearch = res.data;
            // this.data = res.data;
          }
          return res;
        }
      )
    );
  }

  getFormasEnvio(idcomunidad){
    return this.server.get(
      'data/formas_envio?f=idcomunidad&v='+idcomunidad
    );
  }

}
